import { addressSlice } from './address';
import { appSlice } from './app';
import { authSlice } from './auth';
import { cardSlice } from './card';
import { localizationSlice } from './localization';
import { portfolioSlice } from './portfolio';
import { receiveSlice } from './receive';
import { registrationSlice } from './registration';
import { sendSlice } from './send';
import { topUpCardSlice } from './topUpCard';

export {
	addressSlice,
	appSlice,
	authSlice,
	cardSlice,
	localizationSlice,
	portfolioSlice,
	receiveSlice,
	registrationSlice,
	sendSlice,
	topUpCardSlice,
};

export const rootReducer = {
	address: addressSlice.reducer,
	app: appSlice.reducer,
	localization: localizationSlice.reducer,
	registration: registrationSlice.reducer,
	portfolio: portfolioSlice.reducer,
	send: sendSlice.reducer,
	receive: receiveSlice.reducer,
	auth: authSlice.reducer,
	card: cardSlice.reducer,
	topUpCard: topUpCardSlice.reducer,
};
